import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { FirePage } from './FirePage';
import { HouseholdPlanTab } from '../components/retirement/HouseholdPlanTab';

type FireTab = 'simple' | 'household';

const initialTab = (): FireTab =>
  new URLSearchParams(window.location.search).get('tab') === 'household' ? 'household' : 'simple';

/**
 * The FIRE page: the simple Monte Carlo plans (unchanged, used by other
 * households) and the opt-in household plan (issue #32) side by side as
 * tabs. The tab is mirrored in ?tab= so it can be linked to.
 */
export const FireHubPage: React.FC = () => {
  const [tab, setTab] = useState<FireTab>(initialTab);
  const choose = (t: FireTab) => {
    setTab(t);
    const url = new URL(window.location.href);
    if (t === 'household') url.searchParams.set('tab', 'household');
    else url.searchParams.delete('tab');
    window.history.replaceState(window.history.state, '', url.toString());
  };
  return (
    <Box>
      <Box sx={{ px: 3, pt: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_, v) => choose(v)} aria-label="FIRE planner views">
          <Tab value="simple" label="Simple plans" />
          <Tab value="household" label="Household plan" />
        </Tabs>
      </Box>
      {tab === 'simple' ? <FirePage /> : <Box sx={{ p: 3 }}><HouseholdPlanTab /></Box>}
    </Box>
  );
};
